import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconWindow = ({
    width = '16',
    height = '16',
    className,
    ...rest
}: Props) => (
    <svg
        className={classnames(css.main, className)}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            className={css.colored}
            d="M13 1a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h10zm-.5 12a.5.5 0 00.5-.5V6H3v6.5a.5.5 0 00.5.5h9zM4 2.5a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z"
        />
    </svg>
);

export default IconWindow;
